import React from 'react';
import OptionType from 'features/shared/components/selectInput/OptionType';
import SelectInput from 'features/shared/components/selectInput/SelectInput';
import styles from './yearSelect.module.scss';

interface Props {
  startDate: Date;
  endDate: Date;
  selectedYear?: number;
  name?: string;
  className?: string;
  applyMinWidth?: boolean;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const YearSelect = ({ startDate, endDate, selectedYear, name, className, applyMinWidth, onChange }: Props) => {
  // helpers
  const generateYears = (): OptionType[] => {
    let result: OptionType[] = [];
    let startYear = new Date(startDate).getFullYear();
    let endYear = new Date(endDate).getFullYear();

    for (let i = startYear; i <= endYear; i++) {
      result.push({
        value: i.toString(),
        name: i.toString(),
      });      
    }

    return result;
  }

  const getWrapperClasses = (): string => {
    let wrapperClass = applyMinWidth ? styles.yearSelectItem : "";
    wrapperClass = className ? ` ${className}` : "";

    return wrapperClass;
  }

  // render
  return (
    <div className={getWrapperClasses()}>
      <SelectInput 
        name={name ?? "yearSelect"}
        options={generateYears()}
        value={selectedYear}
        onChange={onChange}
        className="mb-0"
      />
    </div>
  )
}

export default YearSelect;
